import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

import { FraudPreventionProvider } from "./fraud-prevention.model";

@Injectable({
	providedIn: "root",
})
export class FraudPreventionConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getIovationUrl(): string {
		// todo: OBGB-11551 move config from common to core
		return this.configService.get(
			(x) => x.common.fraudPrevention.iovationUrl,
			"https://ci-mpsnare.iovation.com/snare.js"
		);
	}

	getProvider(): FraudPreventionProvider {
		// todo: OBGB-11551 move config from common to core
		return this.configService.get(
			(x) => x.common.fraudPrevention.provider,
			FraudPreventionProvider.Noop
		) as FraudPreventionProvider;
	}

	getEnabledInRegistration(): boolean {
		// todo: OBGB-11551 move config from common to core
		return this.configService.get((x) => x.common.fraudPrevention.enabledInRegistration, true);
	}

	getEnabledInLogin(): boolean {
		// todo: OBGB-11551 move config from common to core
		return this.configService.get((x) => x.common.fraudPrevention.enabledInLogin, true);
	}

	getThreatMetrixTokenEndpoint(): string {
		// todo: OBGB-11551 move config from common to core
		return this.configService.get((x) => x.common.fraudPrevention.endpoints!.customerFraud, "v1/customerfraud");
	}

	getGroupIBBackUrl(): string {
		return this.configService.get((x) => x.common.fraudPrevention.groupIBBackUrl);
	}

	getGroupIBCustomerId(): string {
		return this.configService.get((x) => x.common.fraudPrevention.groupIBCustomerId);
	}

	getGroupIBScriptSrc(): string {
		return this.configService.get((x) => x.common.fraudPrevention.groupIBScriptSrc);
	}
}
